import { cn } from '@/lib/utils'

/**
 * The VOYP signature motif: a small animated voice waveform.
 * Used in the LIVE pill, live-call view, and audio players.
 * `active` animates the bars; otherwise they rest at low amplitude.
 */
export function SoundWave({
  active = true,
  bars = 4,
  className,
}: {
  active?: boolean
  bars?: number
  className?: string
}) {
  return (
    <span className={cn('flex h-[1em] items-center gap-[0.14em]', className)} aria-hidden>
      {Array.from({ length: bars }, (_, i) => (
        <span
          key={i}
          className={cn(
            'w-[0.16em] rounded-full bg-current',
            active ? 'h-full animate-sound-bar' : 'h-[35%]',
          )}
          style={active ? { animationDelay: `${(i % 3) * 0.18 + i * 0.07}s` } : undefined}
        />
      ))}
    </span>
  )
}

/** Breathing ring for the live-call state. Wrap around an avatar or icon. */
export function LivePulse({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <span className={cn('relative inline-flex', className)}>
      <span className="absolute inset-0 animate-pulse-ring rounded-full bg-live/60" aria-hidden />
      <span className="relative inline-flex">{children}</span>
    </span>
  )
}
